import { NZ_PRODUCT_IDS } from '../constants';

const isNZProduct = (productId: string): boolean => (NZ_PRODUCT_IDS.includes(productId));

export default isNZProduct;
